import { Button } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { FiEdit } from 'react-icons/fi';

type EditCreditAgreementDocumentWipButtonProps = {
  wipPath: string;
};
export const EditCreditAgreementDocumentWipButton = ({
  wipPath,
}: EditCreditAgreementDocumentWipButtonProps) => {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(wipPath)}
      variant="outline"
      marginLeft={3}
      rightIcon={<FiEdit />}
      aria-label="edit credit agreement document wip"
    >
      Edit WIP
    </Button>
  );
};
